import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'test/';

class MissionService {

    moveOn() {
        return axios.put(API_URL + 'moveon', {}, { headers: authHeader() });
    }

    moveBack() {
        return axios.put(API_URL + 'moveback', {}, { headers: authHeader() });
    }

}

export default new MissionService();